import { render, staticRenderFns } from "./PayPlanLifecycleBadge.vue?vue&type=template&id=5e45db18&scoped=true"
import script from "./PayPlanLifecycleBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPlanLifecycleBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayPlanLifecycleBadge.vue?vue&type=style&index=0&id=5e45db18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e45db18",
  null
  
)

export default component.exports